var _defs, _ellipse, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224.08 275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f5f5;}.cls-2{fill:#ffc99d;}.cls-2,.cls-3,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#2a3561;stroke-miterlimit:10;stroke-width:0.5px;}.cls-2,.cls-8{stroke-linecap:round;}.cls-3{fill:#2b5889;}.cls-4,.cls-7{fill:#2a3561;}.cls-5,.cls-8{fill:none;}.cls-6{fill:#fff;}.cls-9{fill:#37a7f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ELEMENTS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse",
    className: "cls-1",
    cx: 112.04,
    cy: 112.61,
    rx: 112.04,
    ry: 112.61
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nurse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    className: "cls-2",
    x: 90.26,
    y: 249.42,
    width: 15.8,
    height: 13.11
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    className: "cls-2",
    x: 115.85,
    y: 249.42,
    width: 15.8,
    height: 13.11
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    className: "cls-3",
    d: "M130.59,147.35h-43V248.76a3.45,3.45,0,0,0,3.45,3.45H105a3.44,3.44,0,0,0,3.45-3.45h0V158.11a2.49,2.49,0,0,1,2.49-2.49h0a2.49,2.49,0,0,1,2.49,2.49v90.95a3.15,3.15,0,0,0,3.15,3.15h14.54a3.15,3.15,0,0,0,3.15-3.15V147.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    className: "cls-4",
    d: "M87.57,184.7s-.08,7.89,0,8,20.89,0,20.89,0v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    className: "cls-4",
    d: "M113.32,184.7s-.08,7.89,0,8,20.89,0,20.89,0v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    className: "cls-3",
    d: "M154.13,114.15,138.8,76.35a12,12,0,0,0-7.15-6.85,5.34,5.34,0,0,0-2.62-.72H92.87a12,12,0,0,0-11.15,7.57l-15.34,37.8A4.82,4.82,0,0,0,69,120.43a5.13,5.13,0,0,0,.87.26l17.67,3.53V184.7h46.76V124l16.27-3.26a4.82,4.82,0,0,0,3.79-5.66A5.54,5.54,0,0,0,154.13,114.15Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    className: "cls-5",
    x1: 87.57,
    y1: 124.22,
    x2: 87.57,
    y2: 84.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    className: "cls-2",
    d: "M148.44,121.11l2.66,18.57s.94,7.42-5.69,14.07-14.8,13.18-14.8,13.18l-7-15.16,10.72-8.49s3.47-3,3.27-5.22c-.31-3.29-2.38-14.65-2.38-14.65Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    className: "cls-5",
    x1: 134.27,
    y1: 124.22,
    x2: 134.27,
    y2: 84.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    className: "cls-2",
    d: "M113.12,78.46h-3.6a3.91,3.91,0,0,1-3.91-3.91h0V59.7H117V74.54A3.92,3.92,0,0,1,113.12,78.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    className: "cls-4",
    d: "M105.61,64.49s1,3.16,5.71,4.56,5.72.31,5.72.31V64.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    className: "cls-2",
    d: "M111.32,30.68c-13.93,0-12.58,8.43-12.58,8.43V56.24c0,9.78,12.58,10.18,12.58,10.18S123.9,66,123.9,56.24V39.12S125.24,30.68,111.32,30.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    className: "cls-6",
    d: "M116.65,101.65l-5.26,42.2a2.44,2.44,0,0,0,2.12,2.72,2.55,2.55,0,0,0,.87,0l21.38-5.17a3.46,3.46,0,0,0,2.61-2.94l5-41.5a1.79,1.79,0,0,0-1.56-2,1.75,1.75,0,0,0-.51,0l-21.8,3.73A3.43,3.43,0,0,0,116.65,101.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    className: "cls-6",
    d: "M119,118.92l4.58-8.46a7.74,7.74,0,0,1,5.14-4c3.75-.86,17.82-3.54,17.82-3.54a61.12,61.12,0,0,0-7.95,13c-2.69,6-3.73,15.61-4.05,19.36a2.13,2.13,0,0,1-1.67,1.91l-14,3.15a1.23,1.23,0,0,1-1.46-.92,1.45,1.45,0,0,1,0-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    className: "cls-2",
    d: "M128.75,124.22a2.3,2.3,0,0,0-1.9-2.12,3.68,3.68,0,0,0-.48-4.37l-11.74,1.9v-3.27l-7,7.5L87.26,128l.31-3.77-15.19-3-2.85,14.56a7.24,7.24,0,0,0,8.78,8.46l25.45-6s16.14-1.35,18-2.35,2-3.63,2-3.63a5.73,5.73,0,0,0,2-1.43c.79-.95,0-3.37,0-3.37S128.91,126.1,128.75,124.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    className: "cls-7",
    d: "M107.88,36.61s4.2,4.64,16,4.64v2.39l2.67-.08a72.16,72.16,0,0,1-.92-9.63c0-4.1-6.47-6.06-15-6.06S97,31.52,97,34.65s-.8,9.72-.8,9.72h2.51V39.1S101.9,40.09,107.88,36.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    className: "cls-6",
    d: "M135.71,256.63a2.72,2.72,0,0,0-3.15-2.21h0c-2.74.32-10,6.85-12.64,5.9s-3.69-4.32-4.64-4.32a1.86,1.86,0,0,0-2,1.4c-.1.92,0,15.56,0,15.56v1.79h48.24s2.21-3.37-.85-4.74-13.06-1.39-18.22-5.44S135.71,256.63,135.71,256.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    className: "cls-6",
    d: "M86,256.63a2.74,2.74,0,0,1,3.16-2.21h0c2.74.32,10,6.85,12.64,5.9s3.69-4.32,4.63-4.32a1.86,1.86,0,0,1,2,1.4c.1.92,0,15.56,0,15.56v1.79H60.22s-2.21-3.37.85-4.74,13.05-1.39,18.22-5.44S86,256.63,86,256.63Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    className: "cls-8",
    x1: 87.26,
    y1: 128,
    x2: 76.2,
    y2: 130.38
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    className: "cls-8",
    x1: 126.85,
    y1: 122.1,
    x2: 117.98,
    y2: 123.73
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    className: "cls-8",
    x1: 126.18,
    y1: 127.18,
    x2: 117.32,
    y2: 128.81
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    className: "cls-8",
    x1: 124.08,
    y1: 132.26,
    x2: 115.21,
    y2: 133.89
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    className: "cls-9",
    d: "M121.27,150.48l2.9-2.31a1.7,1.7,0,0,1,2.36.52,1.37,1.37,0,0,1,.16.32l6.84,17.53a1.72,1.72,0,0,1-.51,2l-3.32,2.85"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    className: "cls-9",
    x: 93.47,
    y: 93.93,
    width: 12.48,
    height: 6.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "cls-9",
    cx: 99.71,
    cy: 93.27,
    r: 2.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-2",
    d: "M107.33,59.24s.94.94,3.68.94,3.61-.94,3.61-.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    className: "cls-2",
    d: "M123.94,44.38s2.42-1.44,3.24,1.2c1.08,3.43-3.24,6.36-3.24,6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-2",
    d: "M98.7,44.38s-2.42-1.44-3.25,1.2C94.37,49,98.7,51.94,98.7,51.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-2",
    d: "M111,46.55l-2.59,7.58a1.63,1.63,0,0,0,1,2,1.6,1.6,0,0,0,.53.09h2.19"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorDocs);
export default __webpack_public_path__ + "static/media/doctorDocs.2f5aa2f2142464d38b127fe07e9df232.svg";
export { ForwardRef as ReactComponent };